import React from 'react'

const ServiceConfirmation = ({ prevStep, nextStep, values }) => {
    console.log(values);
    const { firstName, lastName, email, salary} = values
    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

    const Previous = e => {
        e.preventDefault();
        prevStep();
    }

    return (
        <div  component="main" maxWidth="xs">
            <div>
                <ul>
                    <li>
                        <span primary="Email" secondary={email}/>
                    </li>
                    <li>
                        <span primary="salary" secondary={salary}/>
                    </li>
                    <li>
                        <span primary="First Name" secondary={firstName}/>
                    </li>
                    <li>
                        <span primary="Last Name" secondary={lastName}/>
                    </li>
                </ul>

                <br />

            </div>
        </div>
    )
}

export default ServiceConfirmation